import {Dispatch, FC, SetStateAction} from 'react'
import {ModalComponent} from '../../../../../components/Layout/Modal'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  message?: string
  file?: any
}

const ModalErrorUpload: FC<Props> = ({show, setShow, message, file}) => {
  const arrayMessage = message?.split('\n')
  const handleClose = () => {
    setShow(false)
  }
  return (
    <ModalComponent type='Alert' variant={'error'} show={show} handleClose={handleClose}>
      <div>
        <p>
          Documento: <span>{file?.name.toUpperCase()}</span>
        </p>
      </div>
      <div>
        <ul className='mb-0'>
          {arrayMessage
            ?.filter((item) => item.trim() !== '') // Filtrar elementos vacíos
            .map((item, index) => (
              <li key={index}>{item}</li>
            ))}
        </ul>
      </div>
    </ModalComponent>
  )
}

export {ModalErrorUpload}
